import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux"; // Import useSelector to access Redux store
import axios from "axios";
import "./Hero.css";

function Hero() {
  const [sliderImages, setSliderImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Get the organizationId from Redux store
  const organizationId = useSelector((state) => state.organization.organizationId);
  useEffect(() => {
    const fetchSliderImages = async () => {
      try {
        // Fetch images based on the organizationId from Redux
        const response = await axios.get(
          `https://watersoft.com.np/WaterTariffSystem-web/webresources/customer/sliderImages/${organizationId}`
        );
        setSliderImages(response.data.imagesList);
      } catch (error) {
        console.error("Error fetching slider images:", error.message);
      }
    };

    if (organizationId) {
      fetchSliderImages(); // Fetch images only if organizationId is available
    }
  }, [organizationId]); // Re-fetch when organizationId changes

  // Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === sliderImages.length - 1 ? 0 : prev + 1
      );
    }, 2000);
    return () => clearInterval(interval);
  }, [sliderImages]);

  const goToPrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? sliderImages.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prev) =>
      prev === sliderImages.length - 1 ? 0 : prev + 1
    );
  };

  if (sliderImages.length === 0) return null;

  return (
    <div className="carousel-container">
      <div className="carousel-slide">
        <img
          src={sliderImages[currentIndex]}
          alt={`slide-${currentIndex}`}
          className="carousel-img"
        />
        <button className="carousel-btn prev" onClick={goToPrev}>
          &#10094;
        </button>
        <button className="carousel-btn next" onClick={goToNext}>
          &#10095;
        </button>
      </div>
      <div className="carousel-dots">
        {sliderImages.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default Hero;



// import React, { useState, useEffect } from "react";
// import "./Hero.css"; // Make sure this file exists with the necessary CSS

// function Hero() {
// const sliderImages = [
//   "/assets/images/testingimage.JPG",
//   "/assets/images/testingimage.JPG",
//   "/assets/images/testingimage.JPG",

// ];


//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) =>
//         prev === sliderImages.length - 1 ? 0 : prev + 1
//       );
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [sliderImages.length]);

//   const goToPrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? sliderImages.length - 1 : prev - 1
//     );
//   };

//   const goToNext = () => {
//     setCurrentIndex((prev) =>
//       prev === sliderImages.length - 1 ? 0 : prev + 1
//     );
//   };

//   return (
//     <div className="carousel-container" style={{marginTop:'1vh'}}> 
//       <div className="carousel-slide">
//         <img
//           src={sliderImages[currentIndex]}
//           alt={`slide-${currentIndex}`}
//           className="carousel-img"
//         />
//         <button className="carousel-btn prev" onClick={goToPrev}>
//           &#10094;
//         </button>
//         <button className="carousel-btn next" onClick={goToNext}>
//           &#10095;
//         </button>
//       </div>
//       <div className="carousel-dots">
//         {sliderImages.map((_, idx) => (
//           <span
//             key={idx}
//             className={`dot ${idx === currentIndex ? "active" : ""}`}
//             onClick={() => setCurrentIndex(idx)}
//           ></span>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Hero;
